import * as HLF from "html-living-framework";
import {Keyboard} from "../gameobjects/Keyboard";
import {VoiceOverManager} from "../managers/VoiceOverManager";
import {LoadScreen} from "./LoadScreen";

export class AbstractGameState extends HLF.State {

    public init(pSize: PIXI.Point, pData?: any) {
        super.init(pSize);

        Keyboard.clear();
        Keyboard.enabled = true;
    }

    public lockScreen() {
        this.interactiveChildren = false;
        Keyboard.enabled = false;
    }

    public unlockScreen() {
        this.interactiveChildren = true;
        Keyboard.enabled = true;
    }

    public gotoNextState<T>(name: string, data?: T) {
        VoiceOverManager.instance.stopVO();
        const steps = [
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.HideLoadScreen,
            HLF.TransitionStep.AttachNewInFront,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.AnimNewIn,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: name, data}, LoadScreen.NAME, ...steps) :
                new HLF.StateToken(name, LoadScreen.NAME, ...steps),
        );
    }
}
